import React from "react";

const GroupCheckbox = (props) => {
  const {
    label = "",
    name = "",
    divClass = "checkbox avaiCheck",
    labelClass = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <a className={divClass}>
        <input name={name} id={props?.id ?? name} type="checkbox" {...extra} />
        <label for={props?.id ?? name} className={labelClass}>
          {label}
        </label>
      </a>
      {children ?? ""}
      {errorMsg ?? ""}
    </li>
  );
};

export default GroupCheckbox;
